import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileDisplayName'
})
export class FileDisplayNamePipe implements PipeTransform {
  transform(fileRef: any): string {
    if (fileRef === null || fileRef === undefined) {
      return '';
    }

    const rawValue = `${fileRef}`.trim();
    if (!rawValue) {
      return '';
    }

    const sanitized = rawValue.split('#')[0].split('?')[0];
    const fileName = sanitized.split('/').pop() || sanitized;
    const dotIndex = fileName.lastIndexOf('.');

    if (dotIndex <= 0) {
      return fileName;
    }

    return fileName.substring(0, dotIndex);
  }
}
